meedy.filter('meedySecondDiagnosisStatusFilter', ['$translate', function ($translate) {
    return function (input) {
        if (typeof input === 'undefined') {
            return;
        }
        else {
            return $translate.instant('T.MEEDY.ENUM.SECOND_DIAGNOSIS_STATUS.' + input);
        }
    };
}]);